/**
 * BuildVersion — ненавязчивый штамп версии сборки в углу экрана (Задача A).
 *
 * Цель: при проверках сразу видно, какая сборка отрендерена — лечит путаницу со
 * stale PWA-кэшем (старый бандл из Service Worker выглядит как новый).
 *
 * Источник — `import.meta.env.VITE_BUILD_ID` (git short-hash + дата/время сборки,
 * инжектится через `define` в vite.config.ts). В тестах/dev без инжекта — 'dev'.
 *
 * P-042 (решение Aibek 2026-06-10): штамп — DEV-only. В ПРОДЕ НЕ рендерим
 * (внутренний trace `<sha> · <дата>` не для пользователя; Vite tree-shake'ит
 * DEV-ветку из прод-бандла). В dev/проверках остаётся для диагностики кэша.
 *
 * Размещение: cross-route оверлей в `RootLayout` (монтируется один раз, как
 * `ScrollToTop` и будущие global modals) — НЕ часть per-screen layout shell (P-046).
 * Дизайн: `fixed` в правом-нижнем углу контентной зоны (над BottomBar), мелким
 * `text-muted` (sanctioned secondary-token #7a6a5a, не нарушает P-039/P-041),
 * `pointer-events-none` — никогда не перехватывает тапы.
 */
export function BuildVersion() {
  if (!import.meta.env.DEV) return null;
  const version = import.meta.env.VITE_BUILD_ID || 'dev';
  return (
    <div
      data-testid="build-version"
      className="fixed bottom-[56px] right-2 z-30 pointer-events-none select-none text-[10px] leading-none text-muted"
    >
      {version}
    </div>
  );
}
